// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from "jquery"
import '@bootstrap/css/bootstrap.css'
import '@css/font.css'
import '@css/common.css'
import '@js/skin/layer.css'
import layer from '@js/layer'
import 'select2/dist/css/select2.min.css'; // 使用 CSS
import VueWechatTitle from 'vue-wechat-title';
import commonJs from '@js/common'
import moment from '@js/moment'
import Dropdown from 'hsy-vue-dropdown'
import iView from 'iview';
import select2 from 'select2';
//import axios from 'axios'
import 'select2/dist/js/i18n/zh-CN.js';
import 'iview/dist/styles/iview.css'; // 使用 CSS
import '@bootstrap/js/bootstrap.min.js'
import Cookies from "js-cookie"
Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.use(iView);
Vue.use(VueWechatTitle)
Vue.use(Dropdown)
Vue.config.debug = true;
//axios.defaults.withCredentials=true;
//Vue.prototype.$axios = axios;
Vue.prototype.common = commonJs.common;
Vue.prototype.layer = layer
Vue.prototype.select2 = select2
Vue.prototype.moment = moment
//Vue.prototype.Cookies = Cookies
moment.lang("zh-cn");
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//axios.defaults.baseURL = process.env.API_ROOT;
function getLocalUser() {
	var user = localStorage.getItem("user");
	if(user) {
		user = JSON.parse(user)
		return user;
	}
	else {
//		if(location.href.indexOf('login') == -1) {
//			location.href = '/login'
//		}
	}
	
}
Vue.prototype.getLocalUser = getLocalUser()
Vue.prototype.Hub = new Vue({})
router.beforeEach((to, from, next) => {
	iView.LoadingBar.start();
	if(to.meta.doNotAuth) { 
		next();
	} else {
//		console.log(Cookies.get('sid'))
//		const token = Cookies.get('sid');
//		if(token) { 
//			next();
//		} else { 
//			next({
//				path: '/login',
//				query: {
//					redirect: to.fullPath
//				} 
//			})
//		}
		next();
	}
	next();
});
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	render: h => h(App),
	template: '<App/>',
	created: function() {},
	mounted:function(){
	},
	methods: {
	}
})



// WEBPACK FOOTER //
// ./src/main.js